import { useEffect, useState } from 'react';
import { format } from 'date-fns';

/** 'ISO' → "dd/MM às HH:mm" (carimbo dos snapshots de insights). */
export const fmtDataHora = (iso?: string | null) =>
  iso ? format(new Date(iso), "dd/MM 'às' HH:mm") : null;

/**
 * true enquanto `liberadaEm` (ISO) está no futuro — e re-renderiza sozinho
 * quando o horário passa, pra o botão Atualizar reabilitar sem o usuário
 * precisar trocar de aba/recarregar. O gate real é o servidor (429); isto é UX.
 */
export function useCooldownAtivo(liberadaEm?: string | null): boolean {
  const alvo = liberadaEm ? new Date(liberadaEm).getTime() : 0;
  const [agora, setAgora] = useState(() => Date.now());

  useEffect(() => {
    const restante = alvo - Date.now();
    if (restante <= 0) return undefined;
    // +1s de folga; cap bem abaixo do limite de 32 bits do setTimeout.
    const t = setTimeout(() => setAgora(Date.now()), Math.min(restante + 1000, 2_000_000_000));
    return () => clearTimeout(t);
  }, [alvo]);

  return alvo > agora;
}
